import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import { Mini } from "@/designSystem/components/mini/mini"
import { DeleteButton, ParentButton } from "@/designSystem/patterns/editor-menu"

type Props = {
  editor: Editor
}

export function ListItemMenu(props: Props) {
  return (
    <Mini.Menu>
      <Mini.Section>
        <ParentButton editor={props.editor} />
      </Mini.Section>
      <Mini.Section>
        <DeleteButton editor={props.editor} />
      </Mini.Section>
    </Mini.Menu>
  )
}
